import {
    updateExistingSpecProperties,
    updateMaterialSpecStatus,
} from "store/features/materialSpecs/specs/specs.actions";
import { SpecsState } from "store/features/materialSpecs/specs/specs.reducer";

export const updateExistingSpecStatusSuccess = (
    state: SpecsState,
    { payload: { specId, status, permissions, materials } }: ReturnType<typeof updateExistingSpecProperties.success>
) => {
    return {
        ...state,
        config: {
            ...state.config,
            lineItemHeader: {
                ...state.config.lineItemHeader,
                rows: state.config.lineItemHeader.rows.map((row) => {
                    if (row.id === specId) {
                        return {
                            ...row,
                            values: row.values.map((value) => {
                                if (value.colour) {
                                    return {
                                        value: status.text,
                                        colour: status.color,
                                        tooltip: status.code.toString(),
                                    };
                                }

                                return value;
                            }),
                        };
                    }

                    return row;
                }),
            },
        },
        materialSpecifications: state.materialSpecifications.map((materialSpec) => {
            if (specId === materialSpec.id) {
                return {
                    ...materialSpec,
                    isStatusUpdateProcessing: false,
                    permissions,
                    materials,
                };
            }

            return materialSpec;
        }),
    };
};

export const updateMaterialSpecStatusRequest = (
    state: SpecsState,
    action: ReturnType<typeof updateMaterialSpecStatus.request | typeof updateExistingSpecProperties.request>
) => {
    return {
        ...state,
        materialSpecifications: state.materialSpecifications.map((materialSpec) => {
            if (action.payload.materialSpecId === materialSpec.id && !materialSpec.isStatusUpdateProcessing) {
                return {
                    ...materialSpec,
                    isStatusUpdateProcessing: true,
                };
            }

            return materialSpec;
        }),
    };
};
